module.exports = __webpack_public_path__ + "img/admin.f6c04597.png";